import {forwardRef, useImperativeHandle, useState} from "react";
import {Modal} from "antd";
import {IconClose} from "../../Icon";
import ChooseImage from "./ChooseImage";
import global from "@/global";
import {MAX_Z_INDEX} from "@/Const";

const DialogChooseImage = forwardRef((props:{onOkClicked:any,from:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog,
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);

    const onShowDialog = ()=>{
        setIsShowDialog(true)
    }

    return(
        <Modal width={334} zIndex={MAX_Z_INDEX} bodyStyle={{margin:'-20px -24px -32px -24px',height:'266px'}} closable={false} open={isShowDialog}
               centered={true} closeIcon={<IconClose/>} footer={''}
               afterOpenChange={(e)=>{
                   if (e){
                       global.g_currentDialogName = 'DialogChooseImage'
                   }else{
                       global.g_currentDialogName = '';
                   }
               }}
               onCancel={()=>{
                   setIsShowDialog(false);
                   window.closeDialogChooseImage();
               }}>
            <ChooseImage onOkClicked={(obj:any)=>{
                setIsShowDialog(false);
                props.onOkClicked(obj);
            }} onCancelClicked={()=>{

            }} from={props.from}></ChooseImage>
        </Modal>
    )
})

export default DialogChooseImage;